import type { ApiLocation } from '#api/tourservice/model/types.ts';
import type { Location } from '#domain/model/Location.ts';

export const mapLocation = (location: ApiLocation): Location => ({
    street: location.address?.street,
    city: location.address?.city,
    zipCode: location.address?.postal_code,
    country: location.address?.country,
    latitude: `${location.coordinates?.latitude}`,
    longitude: `${location.coordinates?.longitude}`,
});
